var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrchai(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 3074",
    width: 59,
    height: 59,
    transform: "translate(0 0)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 14324",
    transform: "translate(-1160 -376)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 728",
    cx: 35.5,
    cy: 35.5,
    r: 35.5,
    transform: "translate(1160 376)",
    fill: "#578498"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1166 382)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12026",
    d: "M33.953,34.7,35.8,40.155H31.635L33.588,34.7Zm9.958,8.37H40.863v1.073h7.511V43.073h-3V34.489h3V33.416H40.863v1.073h3.047ZM30.2,44.146l1.03-2.876h4.957l.966,2.876h1.588l-3.863-10.73H32.687l-3.927,10.73ZM54.362,54.362H23.545V23.544H54.362Z",
    transform: "translate(-9.831 -9.831)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12027",
    d: "M55.158,81.276A29.33,29.33,0,0,0,81.276,55.158H77.649A25.365,25.365,0,0,1,55.158,77.949Z",
    transform: "translate(-23.032 -23.032)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12028",
    d: "M0,55.158A29.33,29.33,0,0,0,26.117,81.276V77.949A25.4,25.4,0,0,1,3.627,55.158Z",
    transform: "translate(0 -23.032)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12029",
    d: "M81.276,26.117A29.33,29.33,0,0,0,55.158,0V3.326A25.4,25.4,0,0,1,77.649,26.117Z",
    transform: "translate(-23.032)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12030",
    d: "M26.117,0A29.33,29.33,0,0,0,0,26.117H3.627A25.365,25.365,0,0,1,26.117,3.326Z",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrchai);
export default __webpack_public_path__ + "static/media/orchai.2f326d5bfd680d160fa7158a869335bf.svg";
export { ForwardRef as ReactComponent };